import { Pill } from '../ui';
import { COLORS } from '../../theme';
import { relativeTime } from '../../lib/format';
import { absoluteTime, formatValue, scopeLabel } from '../../lib/opsFormat';
import type { SwitchRow } from '../../lib/opsOverview';
import { Table, Td, EmptyRow } from './table';

// Section 2 — Runtime Switches. Read-only render of every ops_switches row.
// NO editing controls anywhere.
const COLUMNS = ['Key', 'Value', 'Scope', 'Expires', 'Updated', 'Reason', 'Actor'];

export function SwitchesTable({ rows }: { rows: SwitchRow[] }) {
  return (
    <Table columns={COLUMNS}>
      {rows.length === 0 ? (
        <EmptyRow span={COLUMNS.length} label="No switches set — all features on safe defaults." />
      ) : (
        rows.map((s) => {
          const expired = s.expires_at ? Date.parse(s.expires_at) <= Date.now() : false;
          return (
            <tr key={s.key}>
              <Td mono color={COLORS.text} nowrap>{s.key}</Td>
              <Td mono>{formatValue(s.value)}</Td>
              <Td nowrap><Pill color={s.client_safe ? COLORS.info : COLORS.warn}>{scopeLabel(s.client_safe)}</Pill></Td>
              <Td nowrap color={expired ? COLORS.critical : COLORS.textSecondary}>
                {s.expires_at ? absoluteTime(s.expires_at) : '—'}
                {expired ? ' (expired)' : ''}
              </Td>
              <Td nowrap>{relativeTime(s.updated_at)}</Td>
              <Td>{s.reason ?? '—'}</Td>
              <Td mono nowrap>{s.actor ?? '—'}</Td>
            </tr>
          );
        })
      )}
    </Table>
  );
}
